<div class="col-sm-12">
  <div class="panel-sub-title-alt">{{title}}</div>

  <div class="push-down-15">
    <div class="col-md-9 col-sm-12 nopadding">
      <div class="custom-form-elem">
        <input type="text" />
      </div>
    </div>

    <div class="col-md-3 col-sm-12 nopadding">
      <button class="custom-form-elem-btn-alt" type="button" (click)="addItem()">Add</button>
    </div>
  </div>

  <div class="clear"></div>

  <div class="form-elem-item">
    <div class="val-empty-box-error" *ngIf="selectedItems == null || selectedItems.length == 0">Please select 1 or more</div>
    <ul>
      <li *ngFor="let item of selectedItems"><span>{{item.name}}</span><button type="button" (click)="removeItem(item)"><i class="glyphicon glyphicon-remove"></i></button></li>
    </ul>
  </div>
  <div class="clear"></div>
</div>
